module.exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `V\xe4lj en artikel`,
    "tableResizer": `Storleks\xe4ndrare`
};


//# sourceMappingURL=sv-SE.main.js.map
